;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('imgOnLoad', imgOnLoad)

  /* @ngInject */
  function imgOnLoad () {
    return {
      link: function (scope, element, attrs) {
        element.bind('load', function () {
          scope.$apply(attrs.imgOnLoad)(true)
        })
      }
    }
  }
})()
